module.exports = __webpack_public_path__ + "img/doctor2.2fde35c5.png";